import React, { Component } from "react";
import MastersPage from "../../components/Masters/MastersPage";

class Masters extends Component {
  render() {
    return (
      <div>
        <MastersPage />
      </div>
    );
  }
}

export default Masters;
